import React from "react";
import { Lock } from "lucide-react";

// Calm "Coming soon" placeholder tile. Each Market feature swaps this for its real component later.
export function LockedTile({ icon: Icon, title, desc, testid }) {
  return (
    <div data-testid={testid} className="relative overflow-hidden rounded-2xl border border-am-border bg-am-surface/70 p-4">
      <div className="pointer-events-none absolute -right-8 -top-8 h-24 w-24 rounded-full aura-radial opacity-[0.08] blur-2xl" />
      <div className="flex items-start justify-between gap-3">
        <span className="grid h-10 w-10 place-items-center rounded-xl border border-am-border bg-am-surface2 text-am-text2"><Icon className="h-5 w-5" /></span>
        <span className="inline-flex items-center gap-1 rounded-full p-[1px] aura-gradient text-[10px] font-bold">
          <span className="flex items-center gap-1 rounded-full bg-am-surface px-2 py-0.5 text-white"><Lock className="h-3 w-3" /> COMING SOON</span>
        </span>
      </div>
      <h3 className="mt-3 text-sm font-bold text-white">{title}</h3>
      <p className="mt-1 text-xs leading-relaxed text-am-text2">{desc}</p>
    </div>
  );
}
